import { render, staticRenderFns } from "./fixed-shift.vue?vue&type=template&id=3ed939c2&"
import script from "./fixed-shift.vue?vue&type=script&lang=js&"
export * from "./fixed-shift.vue?vue&type=script&lang=js&"
import style0 from "./fixed-shift.vue?vue&type=style&index=0&id=3ed939c2&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports